import { Component } from "react";

// custom markup
import TableNew, { CELL_TYPES } from "../../../shared/Table";
import { TableCellAccountRedirect } from "../../../shared/Table/components/Cell";
import RefreshButton from "../../../shared/ui/Refresh.Button";

import TableCellOfferActions from "../../../services/applications/tables/TableCellOfferActions";
import TableCellReviewApplicationActions from "../../../services/applications/tables/TableCellReviewApplicationActions";
import TableCellAmount from "./AplicationTableCells/TableCellAmount";
import TableCellTerm from "./AplicationTableCells/TableCellTerm";
import { reviewingApplicationConnector } from "../../../services/applications/reviewing.application.connector";
import { compose } from "redux";

// formaters and other
import _ from "underscore";
import {
  applicationStages,
  applicationEmploymentStatuses,
  applicationLoanPurposes,
} from "admin/shared/dictionary/enums";

// markup
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";

import ApplicationDetails from "./ApplicationDetails/Application.Details.Component";

// icons
import InfoIcon from "@material-ui/icons/InfoOutlined";
import PropTypes from "prop-types";

export function boolRender(value) {
  if (value === true) return "Yes";
  if (value === false) return "No";
  return "not set";
}

export function dictRender(value, dict) {
  // make shure dict is not undefined
  if (!dict) {
    // eslint-disable-next-line no-console
    console.log("dict renderer no dict set");
    dict = {};
  }

  let renderValue = dict[value];

  if (!renderValue) {
    renderValue = "not set";
  }

  return renderValue;
}

class ApplicationsComponent extends Component {
  constructor(props) {
    super(props);

    let columns = this.getCollumns();
    this.state = { columns, isDialogOpen: false };
  }

  UNSAFE_componentWillMount() {
    if (this.props.accountId) {
      this.props.getApplicationsForAccount(this.props.accountId);
    } else if (
      this.props.applications.data &&
      !this.props.applications.data.length &&
      !this.props.applications.fetching
    ) {
      this.props.getApplications();
    }

    this.props.changeApplicationListPage(1);
  }

  addMoreInfo = (row) => {
    this.props.getRowAdditionalData(
      row.AccountId,
      row.Identity,
      row.DirectDebitAccountId,
      row.Id,
    );
  };

  getDetails = (item, accountInfos) => {
    return <ApplicationDetails item={item} accountInfos={accountInfos} />;
  };

  render() {
    var sortedData = _.sortBy(this.props.applications.data, (application) => {
      return new Date(application.DateSubmitted).valueOf();
    }).reverse();

    let refreshFunction = this.props.accountId
      ? this.props.getApplicationsForAccount.bind(this, this.props.accountId)
      : this.props.getApplications;

    return (
      <div className="applications-layout body-height content-padding">
        <RefreshButton onRefreshClick={refreshFunction} />
        <h3>Loanstep: Applications On Hold</h3>
        {!this.props.applications.fetched ? (
          <div> Loading... </div>
        ) : (
          <TableNew
            {...this.props}
            columns={this.state.columns}
            tableKey={"Applications-Review" + !!this.props.accountId}
            selectId={"Id"}
            items={sortedData}
            actionColumnWidth={190}
            showDetailsFun={this.addMoreInfo}
            detailsRenderer={(item) => {
              return this.getDetails(item, this.props.accountInfos);
            }}
          />
        )}
        <br />
        <Button
          variant="contained"
          color="primary"
          icon={<InfoIcon />}
          onClick={this.openInfoDialog}
        >
          Information for application status flow
        </Button>
        <Dialog open={this.state.isDialogOpen} onClose={this.closeInfoDialog}>
          <DialogContent>
            <p>
              <strong>Draft: </strong>next can be Submitted
            </p>
            <p>
              <strong>Submitted: </strong>next can be AwaitingOfferAcceptance or
              FailedAutoReview
            </p>
            <p>
              <strong>AwaitingOfferAcceptance: </strong>passed AutoReview,
              awaiting customer acceptance of offer
            </p>
            <p>
              <strong>AwaitingManualReview: </strong>offer accepted, manual
              review will decide next stage. Next can be AwaitingCompletion (if
              more completions needed), AwaitingOfferAcceptance (if offer
              changed), ManuallyApproved or ManuallyRejected
            </p>
            <p>
              <strong>FailedAutoReview: </strong>manual review will decide next
              stage...
            </p>
            <p>
              <strong>ManuallyApproved: </strong>application life cycle has
              ended, financing is next.
            </p>
            <p>
              <strong>ManuallyRejected: </strong>next can, in theory, be
              AwaitingManualReview (this would be set by some reviewer, sifting
              through manually rejected apps, or by special request)
            </p>
          </DialogContent>
        </Dialog>
      </div>
    );
  }

  openInfoDialog = () => {
    this.setState({ isDialogOpen: true });
  };

  closeInfoDialog = () => {
    this.setState({ isDialogOpen: false });
  };

  getCollumns = () => {
    return [
      {
        key: "AccountId",
        label: "Get ssn",
        visible: true,
        type: CELL_TYPES.ssn,
        filter: false,
      },
      {
        key: "DateSubmitted",
        label: "Submitted",
        visible: true,
        type: CELL_TYPES.date,
      },
      {
        key: "AccountId",
        label: "Account Id",
        visible: false,
        type: CELL_TYPES.text,
        renderer: (value) => {
          return <TableCellAccountRedirect value={value} type={"accountId"} />;
        },
      },
      {
        key: "Stage",
        label: "Application stage",
        visible: true,
        enumDict: applicationStages,
        type: CELL_TYPES.enum,
      },
      {
        key: "AppliedAmount.Amount",
        label: "Amount",
        visible: true,
        renderer: (value, item) => {
          return <TableCellAmount value={value} item={item} />;
        },
      },
      {
        key: "AppliedTerm",
        label: "Term",
        visible: true,
        renderer: (value, item) => {
          return <TableCellTerm value={value} item={item} />;
        },
      },
      {
        key: "LivingCosts.Amount",
        label: "Living costs",
        visible: false,
        type: CELL_TYPES.money,
      },
      {
        key: "Income.Amount",
        label: "Income",
        visible: false,
        type: CELL_TYPES.money,
      },
      {
        key: "HouseholdAdults",
        label: "Adults in household",
        visible: false,
        type: CELL_TYPES.number,
      },
      {
        key: "HouseholdChildren",
        label: "Children in household",
        visible: false,
        type: CELL_TYPES.number,
      },
      {
        key: "CreditsMonthlyCosts.Amount",
        label: "Monthly credit cost",
        visible: false,
        type: CELL_TYPES.money,
      },
      {
        key: "EmploymentStatus",
        label: "Employment",
        visible: false,
        enumDict: applicationEmploymentStatuses,
        type: CELL_TYPES.enum,
      },
      { key: "EmploymentMonths", label: "Employment months", visible: false },
      {
        key: "CreditPurpose",
        label: "Purpose",
        visible: false,
        enumDict: applicationLoanPurposes,
        type: CELL_TYPES.enum,
      },
      { key: "IsPep", label: "PEP", visible: false },
      {
        key: "DateStarted",
        label: "Started",
        visible: false,
        type: CELL_TYPES.date,
      },
      {
        key: "offer",
        label: "Manual offer",
        visible: false,
        filter: false,
        renderer: (value, item) => {
          return (
            <TableCellOfferActions
              setNominalBasedOffer={this.props.setNominalBasedOffer}
              setRiskBasedOffer={this.props.setRiskBasedOffer}
              value={value}
              item={item}
            />
          );
        },
      },
      {
        key: "acctions",
        label: "Actions",
        visible: true,
        filter: false,
        renderer: (value, item) => {
          return (
            <TableCellReviewApplicationActions
              approveApplication={this.props.approveApplication}
              rejectApplication={this.props.rejectApplication}
              value={value}
              item={item}
              getAccountInfoForId={this.props.getAccountInfoForId}
              accountInfos={this.props.accountInfos}
            />
          );
        },
      },
    ];
  };

  static propTypes = {
    getApplicationsForAccount: PropTypes.func,
    getApplications: PropTypes.func,
    getRowAdditionalData: PropTypes.func,
    changeApplicationListPage: PropTypes.func,
    swapApplications: PropTypes.func,
    getAccountInfoForId: PropTypes.func,
    //
    applications: PropTypes.any,
    accountInfos: PropTypes.any,
    accountId: PropTypes.any,
    //
    changeApplicationListFilter: PropTypes.any,
    approveApplication: PropTypes.any,
    rejectApplication: PropTypes.any,
    setNominalBasedOffer: PropTypes.any,
    setRiskBasedOffer: PropTypes.any,
  };
}

export default compose(reviewingApplicationConnector)(ApplicationsComponent);
